module.exports = __webpack_public_path__ + "static/media/background.3f7a707a.webp";